// removed by extract-text-webpack-plugin
module.exports = {"rotate":"J3CVGqktkgNqhBpWpdEwr","sk-bouncedelay":"_1nft_z3wXyVvpIKcb84frK","bounce-bottom":"_7ZO9Ee9fDZhnevfgY05vu"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 2489
// module chunks = 0